<template>
  <section>
    <DemoHeader />
    <DemoContent />
    <DemoCards />
    <DemoGridBullet />
    <DemoDropdown />
    <DemoContentSteps />
    <DemoGridArticles />
    <DemoArticle />
    <DemoTag />
    <DemoCta />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'ComponentDemo',
  components: { ...partials },
  metaInfo: {
    title: 'Component Demo'
  }
}
</script>
